<template>
  <div>
    <section class="hero has-shadow is-grey-ligth">
      <div class="hero-head" style="margin-bottom: 20px;">
        <br />
        <div
          class="container is-flex is-justify-between"
          style="align-items: center; margin: 0px 25px 0 13px;"
        >
          <h1
            class="title has-text-weight-bold has-text-dark is-2"
            style="margin-bottom: 0; text-wrap: nowrap;"
          >
            Factores de riesgo
          </h1>
          <div
            v-if="tokenUser && tokenUser.admin"
            class="text-card"
            v-tooltip.bottom="{
              content: empresa.nombre,
              trigger: isMovil ? 'click' : 'manual',
            }"
          >
            <span class="is-size-6 w-full truncate">{{ empresa.nombre }}</span>
            <p
              v-if="frsm.nombre !== '.....'"
              class="is-size-5 has-text-weight-bold truncate"
            >
              {{ frsm.nombre }}
            </p>
          </div>
        </div>
      </div>
      <div class="hero-foot">
        <!-- Menu -->
        <nav class="tabs is-boxed">
          <div class="container">
            <ul v-if="!isMovil">
              <li
                v-bind:class="{ 'is-active': activo('yDatos') }"
                @click="selectSection({ d: 'yDatos', name: 'Datos' })"
              >
                <a href="#">Datos Frp</a>
              </li>
              <!-- <li
                  v-bind:class="{ 'is-active': activo('yEmpleados') }"
                  @click="selectSection('yEmpleados', 1, 'Empleados')"
              >
                <a href="#">Empleados</a>
              </li> -->
              <li
                v-bind:class="{
                  'is-active': activo('yResultado') || activo('yGuide'),
                }"
                @click="selectSection({ d: 'yGuide', name: 'Guia' })"
              >
                <a href="#">Resultados</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yFiles') }"
                @click="selectSection({ d: 'yFiles', name: 'Anexos' })"
              >
                <a href="#">Anexos</a>
              </li>
              <li
                v-if="tokenUser && tokenUser.admin"
                v-bind:class="{ 'is-active': activo('yHerramientas') }"
                @click="
                  selectSection({ d: 'yHerramientas', name: 'Herramientas' })
                "
              >
                <a href="#">Herramientas</a>
              </li>
            </ul>
            <ul v-if="isMovil">
              <li
                class="is-active"
                v-on:click="showMenuMobile = !showMenuMobile"
              >
                <a href="javascript:void(0)" class="is-flex">
                  {{ title }}
                  <span class="icon is-small">
                    <i class="material-icons">expand_more</i>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </section>

    <div
      style="display: flex;
      justify-content: left;
      margin-left: 40px;
      text-align: center;"
    >
      <!-- Mobile -->
      <div
        v-if="isMovil"
        class="dropdown"
        :class="showMenuMobile ? 'is-active' : ''"
      >
        <div class="dropdown-menu" role="menu">
          <div class="dropdown-content">
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yDatos') }"
              @click="selectSection({ d: 'yDatos', name: 'Datos' })"
            >
              Datos
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{
                'is-active': activo('yResultado') || activo('yGuide'),
              }"
              @click="selectSection({ d: 'yGuide', name: 'Guia' })"
            >
              Resultados
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yFiles') }"
              @click="selectSection({ d: 'yFiles', name: 'Anexos' })"
            >
              Anexos
            </a>
            <a
              v-if="tokenUser && tokenUser.admin"
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yHerramientas') }"
              @click="
                selectSection({ d: 'yHerramientas', name: 'Herramientas' })
              "
            >
              Herramientas
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Container of Components Main -->
    <div
      :class="{
        container: !activo('yGuide'),
        'container-guie': activo('yGuide'),
      }"
      v-if="tokenUser"
    >
      <component
        :is="select"
        :frsm="frsm"
        :process="frsm"
        :tokenUser="tokenUser"
        @selFrs="selFrs"
        @changeFrs="changeFrs"
        @selectSection="selectSection"
      ></component>
    </div>
  </div>
</template>

<script>
import yDatos from "@/components/frpm/DatosFrs.vue";
// import yEmpleadosn from "@/components/frpm/EmpleadosFrs.vue";
import yGuide from "@/components/frpm/GuiaInterpretacion.vue";
import yResultado from "@/components/frpm/Resultados.vue";
import yFiles from "../attached/uploadFilesBoard.vue";
import yHerramientas from "@/components/frpm/Herramientas.vue";
import { mapState } from "vuex";

export default {
  data() {
    return {
      select: "yDatos",
      step: 0,
      title: "Datos",
      frsm: {
        nombre: ".....",
      },
      showMenuMobile: false,
    };
  },
  computed: {
    ...mapState(["tokenUser", "isMovil", "empresa"]),
  },
  methods: {
    selFrs(d) {
      this.frsm = d;
      setTimeout(this.selectSection({ d: "yGuide", name: "Guia" }), 5000);
    },
    changeFrs(d) {
      this.frsm = d;
    },
    selectSection({ d, name }) {
      if (d === "yHerramientas" || d === "yDatos" || this.frsm.nombre !== ".....") {
        this.select = d;
        this.title = name;
        this.closeMenuMobile();
      } else {
        this.$store.dispatch("notify", {
          message: `Selecciona un proceso`,
          type: "is-danger",
        });
        this.closeMenuMobile();
      }
    },
    activo(a) {
      if (a === this.select) {
        return true;
      } else {
        return false;
      }
    },
    closeMenuMobile() {
      this.showMenuMobile = false;
    },
  },
  components: {
    yDatos,
    yResultado,
    yGuide,
    yFiles,
    yHerramientas,
  },
};
</script>

<style lang="scss" scoped>
.contenedor {
  width: 100%;
  position: absolute;
  z-index: 1;
}

.contenedor2 {
  width: 90%;
  position: absolute;
  z-index: 1;
}

.container-guie {
  margin-top: 10px;
}

.tabs.is-toggle li.is-active a {
  background-color: #522687;
  border-color: #905fbf;
  color: white;
  z-index: 1;
}

.hero.is-grey-ligth .tabs.is-boxed li.is-active a {
  background-color: white;
  border: solid 0 white;
  color: #522687 !important;
  box-shadow: #00000029 0px 14px 20px;
}

.hero.is-grey-ligth .tabs.is-boxed li:hover a {
  background-color: rgba(191, 191, 191, 0.475);
  border: solid 0 rgba(191, 191, 191, 0.475) !important;
  color: #522687 !important;
}

.hero.is-grey-ligth {
  padding-left: 40px;
}

.hero.is-grey-ligth .tabs.is-boxed a {
  border: 0px solid transparent;
  border-radius: 4px 4px 0 0;
}

.text-card {
  padding: 3px 10px;
  border-radius: 10px;
  background-color: white;
}

a.dropdown-item.is-active,
button.dropdown-item.is-active {
  background-color: #522687;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/MenuFrs.vue